import { render, staticRenderFns } from "./SeparationTitle.vue?vue&type=template&id=447918e5&scoped=true&"
import script from "./SeparationTitle.vue?vue&type=script&lang=ts&"
export * from "./SeparationTitle.vue?vue&type=script&lang=ts&"
import style0 from "./SeparationTitle.vue?vue&type=style&index=0&id=447918e5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "447918e5",
  null
  
)

export default component.exports